import { Schema } from '@/Data/Schema/SchemaDataClass'

export const getSchema = (name: string, extended?: boolean) => {
  let schema
  let error
  try {
    schema = Schema.all()
      .transform({
        filters: { name, ...(extended && { extended }) },
      })
      .take()[0]
  } catch (e) {
    error = e
  }

  return { schema, error }
}
